import React from 'react';


const Loader = () => {
    return (
        <div className='flex justify-center mt-4'>
            <div class="flex flex-col">
                <div class="w-12 h-12 rounded-full animate-spin
                        border-4 border-solid border-blue-900 border-t-transparent shadow-md">

                </div>


            </div>
        </div>
    );
};

export default Loader;